// renders the upload button and progess. Needs to be a child of sg-upload.
(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgUploadInput', sgUploadInput);

  function sgUploadInput () {
    function linkFunc (scope, el, attr) {
    }

    return {
      restrict: 'E',
      require: '^sg-upload',
      templateUrl: 'app-legacy/components/sg-upload/sg-upload-input.html',
      link: linkFunc
    };

  }
})();
